import React from 'react';
import './Navbar.css';

const Navbar = () => {
  return (
    <div className="navbar">
      <div className="navbar-container">
        <h1>AdCraft</h1>
      </div>
    </div>
  );
};

export default Navbar;
